module.exports = __webpack_public_path__ + "img/T2.1b993cf7.png";